/* Upsell discret de la fiche produit. L'ajout au panier est géré par quick-add.js
   (boutons [data-qa-add] dans un conteneur [data-qa]). */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-upsell]');
  if (!root) return;
  var cfg = root.dataset;
  var list = root.querySelector('[data-pu-list]');
  var limit = parseInt(cfg.limit, 10) || 4;
  var currentId = parseInt(cfg.productId, 10);

  /* Familles : mêmes règles que l'upsell du panier (cart-upsell-side.js) */
  function norm(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); }
  var RX_BONNET = /\b(bonnets?|cagoules?|underscarf)\b/;
  var RX_HIJAB = /\b(hijabs?|khimars?|foulards?|chales?|echarpes?|turbans?)\b|carre de soie/;
  var RX_CLOTHING = /^(maxi\s+)?(robes?|ensembles?|sets?|pantalons?|jupes?|blouses?|tops?|chemises?|blazers?|vestes?|manteaux?|trenchs?|gilets?|cardigans?|pulls?|abayas?|kimonos?|palazzos?|jeans?|tuniques?|burkinis?|coats?|capes?|ponchos?|sweats?|salopettes?|basic|bohemian|polos?|t-shirts?|dress)\b/;
  var RX_ACCESSORY = /\b(sacs?|pochettes?|boucles? d.oreilles?|bijoux?|colliers?|bracelets?|bagues?|ceintures?|broches?)\b/;
  function kindOf(title, fallback) {
    var t = norm(title);
    if (RX_BONNET.test(t)) return 'bonnet';
    if (RX_CLOTHING.test(t)) return 'clothing';
    if (RX_HIJAB.test(t)) return 'hijab';
    if (RX_ACCESSORY.test(t)) return 'accessory';
    return fallback || 'clothing';
  }
  var cols = (cfg.productCollections || '').split(',');
  var hijabCol = cfg.hijabCollection || 'hijabs';
  var accHandlesAll = (cfg.accessoryCollections || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  var colFallback = cols.indexOf(hijabCol) > -1 ? 'hijab'
    : accHandlesAll.some(function (h) { return cols.indexOf(h) > -1; }) ? 'accessory' : 'clothing';
  var current = kindOf(cfg.productTitle, colFallback);

  // [famille, nombre maximum]
  var plan = current === 'accessory' ? [['clothing', limit]]
    : current === 'hijab' ? [['bonnet', 2], ['accessory', limit]]
    : current === 'bonnet' ? [['hijab', 2], ['accessory', limit]]
    : [['accessory', limit]];
  var titleEl = root.querySelector('[data-pu-title]');
  if (titleEl) titleEl.textContent = current === 'accessory' ? 'Complétez votre look' : 'Accessoirisez votre tenue';

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function () { return {}; });
  }
  function cents(v) {
    if (v === null || v === undefined || v === '') return 0;
    return typeof v === 'string' ? Math.round(parseFloat(v) * 100) : v;
  }
  function money(c) {
    var fmt = cfg.moneyFormat || '{{amount_with_comma_separator}} €';
    function d(n, prec, th, dec) {
      var p = (n / 100).toFixed(prec).split('.');
      return p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (p[1] ? dec + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return d(c, 2, ',', '.');
      if (k === 'amount_no_decimals') return d(c, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return d(c, 0, '.', ',');
      if (k === 'amount_with_space_separator') return d(c, 2, ' ', ',');
      return d(c, 2, '.', ',');
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function img(src) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=260';
  }
  function normalize(p) {
    var variants = (p.variants || []).map(function (v) {
      return { id: v.id, title: v.title, available: v.available !== false, price: cents(v.price), compare: cents(v.compare_at_price) };
    });
    var avail = variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    return {
      id: p.id, title: p.title, url: p.url || ('/products/' + p.handle),
      image: p.featured_image || (p.images && p.images[0]) || '',
      variants: variants, single: variants.length === 1,
      price: avail[0].price, compare: avail[0].compare
    };
  }

  function collection(handle, n) {
    return getJSON(cfg.collectionsUrl + '/' + handle + '/products.json?limit=' + n).then(function (d) { return d.products || []; });
  }
  function interleave(lists) {
    var out = [], i = 0, more = true;
    while (more) { more = false; lists.forEach(function (l) { if (l[i]) { out.push(l[i]); more = true; } }); i++; }
    return out;
  }
  function poolFor(kind) {
    if (kind === 'accessory') return Promise.all(accHandlesAll.map(function (h) { return collection(h, 60); })).then(interleave);
    if (kind === 'bonnet') return Promise.all(accHandlesAll.concat([hijabCol]).map(function (h) { return collection(h, 250); })).then(function (l) { return [].concat.apply([], l); });
    if (kind === 'hijab') return collection(hijabCol, 60);
    return collection(cfg.clothingCollection, 30);
  }
  var STOP = /^(bonnet|bonnets|tube|hijab|hijabs|maxi|jersey|liquid|premium|lux|luxe|satine|soie|de|du|la|le|les|et|en|a)$/;
  function words(t) { return norm(t).split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2 && !STOP.test(w); }); }
  function byColour(cands) {
    var ref = {};
    words(cfg.productTitle).forEach(function (w) { ref[w] = true; });
    return cands.map(function (c, i) { return { c: c, i: i, s: words(c.title).filter(function (w) { return ref[w]; }).length }; })
      .sort(function (a, b) { return b.s - a.s || a.i - b.i; }).map(function (x) { return x.c; });
  }

  function collect() {
    var base = cfg.recoUrl + '.json?product_id=' + currentId + '&limit=10&intent=';
    return Promise.all([getJSON(base + 'complementary'), getJSON(base + 'related')]).then(function (r) {
      var recos = (r[0].products || []).concat(r[1].products || []);
      return Promise.all(plan.map(function (p) { return poolFor(p[0]); })).then(function (pools) {
        var out = [], seen = {};
        seen[currentId] = true;
        plan.forEach(function (p, n) {
          var cands = recos.concat(pools[n]).filter(function (raw) {
            return !seen[raw.id] && kindOf(raw.title) === p[0];
          });
          if (p[0] === 'bonnet') cands = byColour(cands);
          var taken = 0;
          cands.forEach(function (raw) {
            if (out.length >= limit || taken >= p[1] || seen[raw.id]) return;
            var it = normalize(raw);
            if (it) { seen[raw.id] = true; out.push(it); taken++; }
          });
        });
        return out;
      });
    });
  }

  function itemHTML(p) {
    var sale = p.compare > p.price;
    var act;
    if (p.single) {
      act = '<button type="button" data-qa-add data-variant-id="' + p.variants[0].id + '"><span data-qa-txt>Ajouter</span></button>';
    } else {
      act = '<span class="pu__lbl" data-qa-txt>Ajouter en</span>' + p.variants.map(function (v) {
        return '<button type="button" data-qa-add data-variant-id="' + v.id + '"' + (v.available ? '' : ' disabled') +
          ' aria-label="Ajouter ' + esc(p.title) + ' taille ' + esc(v.title) + '">' + esc(v.title) + '</button>';
      }).join('');
    }
    return '<div class="pu__item" data-qa>' +
      '<a class="pu__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(img(p.image)) + '" alt="' + esc(p.title) + '" loading="lazy" width="260" height="347">' : '') + '</a>' +
      '<a class="pu__name" href="' + esc(p.url) + '" title="' + esc(p.title) + '">' + esc(p.title) + '</a>' +
      '<span class="pu__price">' + money(p.price) + (sale ? '<s>' + money(p.compare) + '</s>' : '') + '</span>' +
      '<div class="pu__act">' + act + '</div></div>';
  }

  function start() {
    collect().then(function (products) {
      if (!products.length) return;
      list.innerHTML = products.map(itemHTML).join('');
      root.hidden = false;
    });
  }
  // Chargé quand le bloc approche de l'écran, pour ne pas ralentir l'affichage de la fiche
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
    }, { rootMargin: '400px 0px' });
    // Le bloc est masqué tant qu'il est vide : on observe son parent
    io.observe(root.parentElement || document.body);
  } else {
    start();
  }
})();
